import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaCalendarAlt, FaClock, FaUserCheck, FaCoffee, FaCar } from 'react-icons/fa';

const PlanVisit = () => {
  return (
    <section className="visit-section">
      <motion.div
        className="visit-header"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <h2> Plan Your Visit</h2>
        <p>We are excited to welcome you! Here is everything you need to know before you arrive.</p>
      </motion.div>

      <div className="visit-grid">
        <motion.div className="visit-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }} viewport={{ once: true }}>
          <FaMapMarkerAlt className="visit-icon" />
          <h3>Location</h3>
          <p>97 Hensman Street, South Perth, WA</p>
        </motion.div>

        <motion.div className="visit-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }} viewport={{ once: true }}>
          <FaCalendarAlt className="visit-icon" />
          <h3>Service Day</h3>
          <p>Every Sunday</p>
        </motion.div>

        <motion.div className="visit-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }} viewport={{ once: true }}>
          <FaClock className="visit-icon" />
          <h3>Time</h3>
          <p>10:00 AM – 12:00 PM</p>
        </motion.div>

        <motion.div className="visit-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 0.8 }} viewport={{ once: true }}>
          <FaUserCheck className="visit-icon" />
          <h3>What to Expect</h3>
          <p>Spirit-filled worship, heartfelt teaching, and a warm community ready to welcome you.</p>
        </motion.div>

        <motion.div className="visit-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 1 }} viewport={{ once: true }}>
          <FaCar className="visit-icon" />
          <h3>Free Parking</h3>
          <p>Plenty of free parking available on-site; no stress, just arrive and enjoy.</p>
        </motion.div>

        <motion.div className="visit-card" initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} transition={{ delay: 1.2 }} viewport={{ once: true }}>
          <FaCoffee className="visit-icon" />
          <h3>Light Refreshments</h3>
          <p>Enjoy complimentary tea, coffee, and light snacks after service. Stay and connect!</p>
        </motion.div>
      </div>

      <motion.div
        className="visit-cta"
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ delay: 1.4 }}
        viewport={{ once: true }}
      >
        <p>Let us know you are coming. We will have a seat and a smile ready for you!</p>
        <a href="/visit" className="visit-button">Plan Your Visit</a>
      </motion.div>
    </section>
  );
};

export default PlanVisit;
